import React from "react";

const Title = () => {
  return (
    <div className="title">
      <h1>Gallery App</h1>
      <h2>My Pictures</h2>
      <p>Upload your Pictures Here</p>
    </div>
  );
};

export default Title;
